<template>
  <v-row>
    <v-col 
      cols="12"
      v-for="type_sponsor in types_sponsors"
      v-bind:key="type_sponsor.id">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
        class="pb-4"
        v-if="type_sponsor.is_visible"  
      >
        <v-row class="pa-4" v-if="!loading" >

          <v-col class="pl-4" cols="12">
            <h2 class="font-weight-regular">{{ type_sponsor.name }}:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-for="sponsor in type_sponsor.sponsors" :key="sponsor.id">
            <cardSponsor :sponsor="sponsor"/>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'typeSponsorsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import cardSponsor from '@/components/card/cardSponsor'

  export default {
    name: 'newSponsorsEdition',
    components:{cardSponsor},

    data: () => ({
      loading:true,

      sponsors:[],
      types_sponsors:[],

      edition_id: null,
      types_sponsor_id: null,
      sponsor_id: null,
    }),

    methods:{
      async getAllSponsorsEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/types-sponsors/all-sponsors').then(response =>{
          this.types_sponsors = response.data.data.types_sponsors
          this.sponsors = response.data.data.sponsors
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.getAllSponsorsEdition()
    },
  }
</script>
